import React, { FC } from 'react';
import './loader.scss';

const Loader: FC = (): JSX.Element => {
  return (
    <div className='loader-wrapper'>
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
